const O = () => {
  return (
    <div>
      <svg
        width="66.101"
        height="72.401"
        viewBox="0 0 66.101 72.401"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="svgGroup"
          stroke-linecap="round"
          fill-rule="evenodd"
          font-size="9pt"
          stroke="#000"
          stroke-width="0.25mm"
          fill="black"
          // style="stroke:#000;stroke-width:0.25mm;fill:black"
        >
          <path
            d="M 0.969 26.468 A 46.437 46.437 0 0 0 0 36.101 A 48.913 48.913 0 0 0 0.036 37.961 A 42.769 42.769 0 0 0 2.25 50.201 A 39.376 39.376 0 0 0 2.69 51.424 A 34.353 34.353 0 0 0 8.75 61.751 Q 13 66.701 19.1 69.551 A 29.142 29.142 0 0 0 25.409 71.643 A 36.51 36.51 0 0 0 33 72.401 A 38.35 38.35 0 0 0 38.162 72.064 A 30.074 30.074 0 0 0 46.9 69.551 Q 53 66.701 57.3 61.751 Q 61.6 56.801 63.85 50.201 Q 66.1 43.601 66.1 36.101 Q 66.1 28.601 63.8 22.051 A 39.664 39.664 0 0 0 63.352 20.837 A 34.562 34.562 0 0 0 57.25 10.601 Q 53 5.701 46.85 2.851 A 29.531 29.531 0 0 0 41.066 0.877 A 35.739 35.739 0 0 0 33 0.001 A 39.631 39.631 0 0 0 27.726 0.34 A 30.859 30.859 0 0 0 19.1 2.751 Q 13 5.501 8.75 10.351 A 31.476 31.476 0 0 0 6.518 13.217 A 34.76 34.76 0 0 0 2.25 21.801 A 40.316 40.316 0 0 0 0.969 26.468 Z M 9.7 36.101 Q 9.7 41.501 11.25 46.601 A 28.9 28.9 0 0 0 14.228 53.312 A 26.021 26.021 0 0 0 15.8 55.601 Q 18.8 59.501 23.15 61.851 A 19.631 19.631 0 0 0 30.649 64.088 A 24.113 24.113 0 0 0 33 64.201 A 26.486 26.486 0 0 0 38.119 63.728 A 20.027 20.027 0 0 0 43.15 62.051 Q 47.5 59.901 50.45 56.151 A 24.679 24.679 0 0 0 53.942 50.037 A 30.056 30.056 0 0 0 54.9 47.251 A 37.865 37.865 0 0 0 56.282 39.408 A 45.286 45.286 0 0 0 56.4 36.101 Q 56.4 30.701 54.8 25.701 A 29.351 29.351 0 0 0 51.147 18.11 A 27.264 27.264 0 0 0 50.2 16.801 Q 47.2 12.901 42.85 10.551 A 19.631 19.631 0 0 0 35.352 8.313 A 24.113 24.113 0 0 0 33 8.201 Q 27.5 8.201 23.15 10.351 Q 18.8 12.501 15.8 16.251 A 25.203 25.203 0 0 0 12.057 22.784 A 30.211 30.211 0 0 0 11.25 25.101 Q 9.7 30.201 9.7 36.101 Z"
            vector-effect="non-scaling-stroke"
          />
        </g>
      </svg>
    </div>
  );
};
export default O;
